/* Menú móvil (D-6, corrige M-4): botón con aria-expanded, panel desplegable,
   cierre con Escape, al pulsar fuera y al navegar, y foco visible. */
(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var panel = document.querySelector('[data-menu-panel]');
  var overlay = document.querySelector('[data-menu-overlay]');
  if (!toggle || !panel) return;

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('data-open', open ? 'true' : 'false');
    if (overlay) overlay.hidden = !open;
    if (open) {
      document.body.setAttribute('data-menu-open', 'true');
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    } else {
      document.body.removeAttribute('data-menu-open');
    }
  }

  toggle.addEventListener('click', function () {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  panel.addEventListener('click', function (event) {
    if (event.target.closest('a')) setOpen(false);
  });

  if (overlay) overlay.addEventListener('click', function () { setOpen(false); });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (toggle.getAttribute('aria-expanded') !== 'true') return;
    setOpen(false);
    toggle.focus();
  });

  window.matchMedia('(min-width: 901px)').addEventListener('change', function (event) {
    if (event.matches) setOpen(false);
  });

  setOpen(false);
})();
